module.exports = "<div class=\"ui padded grid\">\n  <div class=\"sixteen wide column\">\n    <div class=\"ui buttons\">\n      <button class=\"ui button\"\n        v-for=\"language in availableLanguages\"\n        v-bind:class=\"{active: currentLanguage.code == language.code}\"\n        v-on:click=\"changeLanguage(language.code)\"\n      >{{ language.nativeName }} / {{ language.name }}</button>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/application/components/application-area/settings/template.html
// module id = 87
// module chunks = 0